import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'linqts';
import { TotemService } from '../totem.service';
import { AnimateMapService } from './animate-map.service';
import { TotemConfiguracion } from '../totem-configuracion';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { StorageService } from '../storage.service';
import { AnalyticsService } from '../services/analytics.service';

// JQuery
declare const $;

@Component({
  selector: 'app-wayfinding',
  templateUrl: './wayfinding.component.html',
  styleUrls: ['./wayfinding.component.css']
})
export class WayfindingComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input()
  option = 'tiendas';
  @Input()
  piid = 0;
  @Input()
  access;
  @Input()
  tipoTransporte =  environment.tipoTransporte.pie;

  @Input() totem = environment.totem;

  private accesos = Array<any>();
  private path: any;
  private activeFloor = '';
  private nodo: any;
  private showServiciosBar = false;
  private showBackToServices = false;
  private mode = '';
  private hasActiveRoute = false;

  public planos: [any];
  public otherPlanos: [any];
  public esHorizontal;

  public puntoInteres;
  public servicios;
  public tipoAcceso;

  public loading = true;

  totemConfig: TotemConfiguracion;
  public buttonDisable = true;

  private mapReady: Subject<boolean> = new Subject<boolean>();

  constructor(
    private activeRoute: ActivatedRoute,
    private totemService: TotemService,
    private animateMapService: AnimateMapService,
    private localStorage: StorageService,
    private analytics: AnalyticsService,
  ) {}

  async ngOnInit() {

    
    const routeParams = this.activeRoute.snapshot.params;

    this.totem = routeParams.totem && routeParams.totem !== '0' ? Number(routeParams.totem) : 202;
    this.totemConfig = await this.totemService.setTotemConfig(this.totem);
    // this.totemConfig = await this.totemService.getTotemConfig(this.totem);
    console.log('this.totem',this.totem);
    this.piid = routeParams.piid ? Number(routeParams.piid) : 0;
    this.option = routeParams.opt ? routeParams.opt : 'tiendas';
    this.access = routeParams.acc ? Number(routeParams.acc) : 0;
    this.tipoTransporte = routeParams.transporte ? Number(routeParams.transporte) :  environment.tipoTransporte.pie;
    this.animateMapService.cleanInstructions();
    console.log('inicio planos')
    this.otherPlanos = await this.totemService.getPlanos().toPromise();
    // $('.screen-layer-1 .planta no-visible').remove();
    for (const plano of this.otherPlanos) {
      $('.screen-layer-1')
      .append('<img src="' + plano.plano_imagen + '" class="planta no-visible" id="planta-' +
      this.calcSiglaPiso(plano.piso_numero) + '-' + this.totemConfig.orientacionId + '" />');
    }
    
    console.log('------------------- datos obtenidos ---------------');
    console.log('this.totem ', this.totem);
    console.log('this.piid', this.piid);
    console.log('this.option ', this.option);
    console.log('this.access ', this.access);
    console.log('this.tipoTransporte', this.tipoTransporte);
    console.log('this.totem config', this.totemConfig);
    await this.initMap();

  }

  async ngOnChanges(changes: SimpleChanges) {
    console.log('CHANGES ', changes);
    this.cancelartimer();
    await this.mapReady.toPromise();

    if (this.option === 'estacionamiento' && this.piid) {
      await this.animateMapService.reiniciar();
      await this.initEstacionamiento();
    } else if (this.access) {

      await this.initAccesos();

    } else if (this.option === 'totem') {
      await this.animateMapService.initMapTotem(this.totemConfig);
      await this.initShowTotem();

    }
  }

  async ngAfterViewInit() {
    try {
      const resultadoLocal = this.localStorage.getNodosRuta();
      console.log("resultadoLocal after", resultadoLocal)
      // this.totemConfig = await this.totemService.getTotemConfig(resultadoLocal.totemInicio);
      this.totemConfig = await this.totemService.setTotemConfig(resultadoLocal.totemInicio);

      
      console.log('ID Angulo de Orientación after', this.totemConfig.orientacionId , );
      const horizontal = environment.orientacionHor;
      const vertical = environment.orientacionVer;
      if (this.totemConfig.orientacionId === horizontal[0] || this.totemConfig.orientacionId === horizontal[1]) {
        this.esHorizontal = true;
      } else if (this.totemConfig.orientacionId === vertical[0] || this.totemConfig.orientacionId === vertical[1]) {
        this.esHorizontal = false;
      }

      if (!this.piid) {
        this.piid = Number(this.activeRoute.snapshot.params.id);
      }

      if (this.esHorizontal) {
        $('.screen-layer-2').addClass('screen-layer-horizontal');
      } else {
        $('.screen-layer-2').addClass('screen-layer-vertical');
      }

    } catch (err) {
      console.error(err);
    }
  }

  ngOnDestroy() {
    this.animateMapService.resetFloor();
    this.animateMapService.propiedadesMapa.pisoActivo = '';
  }

  async initMap() {
    this.cancelartimer();
    const resultadoLocal = this.localStorage.getNodosRuta();
    console.log('resultadoLocal init', resultadoLocal);
    this.totemConfig = await this.totemService.setTotemConfig(resultadoLocal.totemInicio);
    console.log('this.totemConfig init', this.totemConfig);
    console.log('ID Angulo de Orientación init', this.totemConfig.orientacionId);
    
    // const planos = await this.totemService.getPlanos().toPromise();
    // for (const plano of planos) {
    //   $('.screen-layer-1')
    //   .append('<img src="' + plano.plano_imagen + '" class="planta no-visible" id="planta-' +
    //   this.calcSiglaPiso(plano.piso_numero) + '-' + this.totemConfig.orientacionId + '" />');
    // }

    const zoomIn = this.option === 'servicios' ? false : true;

    await this.animateMapService.initMap(this.totemConfig, zoomIn);
    await this.initService(this.option);

    this.mapReady.next(true);
    this.mapReady.complete();
  }

  async resetRoute() {
    this.buttonDisable = true;
    $('.btn-tool').prop('disabled', true);
    this.cancelartimer();
    this.animateMapService.cleanInstructions();
    if (this.option === 'tiendas') {
      await this.animateMapService.reiniciar();
      this.initPuntoInteres();
    } else if (this.option === 'estacionamiento') {
      this.initEstacionamiento();
    } else if (this.option === 'servicios') {
      this.initAccesos();
    }
  }

  async activarTransporteAlternativo(tipo: boolean) {
    this.tipoTransporte = tipo ? environment.tipoTransporte.pie : environment.tipoTransporte.alternativo;
    this.buttonDisable = true;
    $('.btn-tool').prop('disabled', true);
    this.cancelartimer();
    this.animateMapService.cleanInstructions();
    if (this.option === 'tiendas') {
      await this.animateMapService.reiniciar();
      this.initPuntoInteres();
    } else if (this.option === 'estacionamiento') {
      this.initEstacionamiento();
    } else if (this.option === 'servicios') {
      this.initAccesos();
    }
  }

  async initService(option: string): Promise<void> {
    console.log('inicio servicio ', option);
    switch (option) {
      case 'tiendas':
        await this.initPuntoInteres();
        break;
      case 'servicios':
        await this.initAccesos();
        break;
      case 'estacionamiento':
        await this.initEstacionamiento();
        break;
    }
  }

  async initPuntoInteres(): Promise<void> {
    if (!this.piid) {
      console.log('Falta el Piid');
      return;
    }
    console.log('pid', this.piid);
    this.mode = 'tiendas';

    if (!this.puntoInteres) {
      const tiendas = await this.totemService.getTiendas('es').toPromise();
      this.puntoInteres = tiendas.find(tienda => {
        return tienda.punto_interes === this.piid;
      });
    }

    this.goto(this.puntoInteres, this.tipoTransporte, this.mode);

  }

  async initEstacionamiento(): Promise<void> {
    if (!this.piid) {
      console.log('Falta el Piid');
      return;
    }
    this.animateMapService.cleanInstructions();
    this.mode = 'estacionamiento';
    this.puntoInteres = { punto_interes: this.piid };
    this.goto(this.puntoInteres, this.tipoTransporte, this.mode);
  }
  async initShowTotem(): Promise<void> {

    const response = await this.totemService.getNodos().toPromise();
    const Totemnode = response.find((item) => {
        if (item.nod_id === this.totemConfig.nodoId) {
          return item.orientacion === this.totemConfig.orientacionId;
        }
      });
    console.log('Totemnode', Totemnode);
    const imagentotem = 'assets/img/ud-esta-aqui.png';
    let pin = '';

    if (this.esHorizontal) {
      pin = '<img style="width: 3%; height: 6%; margin-left: 1%;  margin-top: 1%;"  id="acceso-' +  Totemnode.nod_id +
    '" data-id="' + Totemnode.nod_id +
    '" src="' + imagentotem + '"></div>';
    } else {
      pin = '<img style="width: 3%; height: 6%; margin-left: 1.2%;  margin-top: .6%;"  id="acceso-' +  Totemnode.nod_id +
      '" data-id="' + Totemnode.nod_id +
      '" src="' + imagentotem + '"></div>';
    }

    const bounces = 3;
    await this.animateMapService.showPin(Totemnode, pin, bounces);

  }

  async initAccesos(autoRoute = true): Promise<void> {
    const tiposAccesos: any[] = await this.totemService
      .getTipoAccesos()
      .toPromise();

    this.servicios = tiposAccesos.filter(tipoAcceso => {
      return tipoAcceso.visible_tipo_acceso !== 0;
    });

    if (this.access) {
      this.mode = 'servicios';
      this.animateMapService.setMode(this.mode);
      this.access = Number(this.access);
      this.tipoAcceso = this.servicios.find(tipoAcceso => {
        return tipoAcceso.id_tipo_acceso === this.access;
      });

      this.accesos = await this.totemService
        .getAccesos(this.access)
        .toPromise();

      console.log('PISO ACTIVO', this.animateMapService.getActiveFloor(true));

      const accesosPiso = this.accesos.filter(acceso => {
        return acceso.piso === this.animateMapService.getActiveFloor(true);
      });
      $('.screen-layer-3').children().remove();
      accesosPiso.forEach(async accesoPiso => {
        const node = this.animateMapService.nodos.find((nodo: any) => {
          return nodo.nod_id === accesoPiso.nodo;
        });

        // let pin = '<div (click) = "goto(' + accesoPiso.acc_id +  ' , '  +  this.tipoTransporte +
        //  ', \'servicios\')" class="talk-bubble tri-right round btm-left no-visible" id="acceso-' +
        //   node.nod_id +
        //   '">';
        // pin +=
        //   '<img id="acceso-' +
        //   node.nod_id +
        //   '" data-id="' +
        //   node.nod_id +
        //   '" src="' +
        //   this.tipoAcceso.imagen_tipo_acceso +
        //   '"></div>';

        // const bounces = 1;
        // await this.animateMapService.showPin(node, pin, bounces);
      });

      if (autoRoute) {
        const route = await this.getShortestRouteToAccess(
          this.accesos,
          this.tipoTransporte
        );
        this.goto(null, this.tipoTransporte, 'servicios', route);
      }

      // });

      return;
    }
  }

  showFloor(floor) {
    // Obtengo sigla de la orientacion
    this.animateMapService.showFloor(
      floor + '-' + this.totemConfig.orientacionId
    );
  }

  async goto(destino, transporte, mode, ruta?): Promise<void> {
    this.cancelartimer();
    console.log('goto', destino);
    if (!destino && this.mode !== 'servicios') {
      return;
    }
    this.buttonDisable = true;
    $('.btn-tool').prop('disabled', true);

    console.log(
      '[ACTIVE ROUTE?]',
      this.animateMapService.propiedadesMapa.rutaActiva
    );

    if (this.animateMapService.propiedadesMapa.rutaActiva) {
      return;
    }

    let tipoDestino = 0;
    let pin = '';
    let routeToDraw = null;
    let firstNode = null;
    let lastNode = null;
    const bounces = 3;

    this.loading = false ;
    switch (mode) {
      case 'tiendas':
        tipoDestino = 1;
        console.log("punto de i ",destino)
        const rutaPI = await this.getRutasPI(
          destino.punto_interes,
          transporte,
          undefined,
          tipoDestino
        );
        console.log('Data getRutasPI', rutaPI);

        routeToDraw = new List(rutaPI)
          .Join(
            new List<any>(this.animateMapService.nodos),
            (routePI: any) => routePI.nodo_ruta,
            node => node.nod_id,
            (routePI, node) => {
              return { route: routePI, node };
            }
          )
          .ToArray();
          console.log('route to draw', routeToDraw);

          
          

        await this.animateMapService.drawRoute(routeToDraw);
        lastNode = routeToDraw[routeToDraw.length - 1].node;
        // pin = '<div class="tooltip-pi acceso-pin no-visible-pin tienda-pin" id="acceso-'+lastNode.nod_id+'">';
        // pin += '<img  id="acceso-'+lastNode.nod_id+'" data-id="'+lastNode.nod_id+'" src="'+destino.logo +'"></div>';

        pin = '<div class="tooltip-pi acceso-pin no-visible-pin tienda-pin" id="acceso-'+lastNode.nod_id+'">';
        pin += '<img  id="acceso-'+lastNode.nod_id+'" data-id="'+lastNode.nod_id+'" src="'+destino.logo +'"></div>';
        await this.animateMapService.showPin(lastNode, pin, bounces);

        this.animateMapService.ListaInstrucciones.push({a: 'hasLlegado', b: 'assets/img/map-marker.png'});
       

        break;

      case 'servicios':
        const nodoTotem = this.animateMapService.nodoTotem;
        const x = this.animateMapService.escalarX(nodoTotem.posicionx);
        const y = this.animateMapService.escalarY(nodoTotem.posiciony);
        const zoom = 1;
        const duracion = 1000;
        const delay = 0;

        this.access = Number(this.access);
        const ultimoacceso = this.servicios.find(tipoAcceso => {
          return tipoAcceso.id_tipo_acceso === this.access;
        });
        console.log('tipo de acceso de accesos', this.tipoAcceso);

        // await this.animateMapService.centreOn(x, y, zoom, duracion, delay);

        const nodeList = ruta
          ? ruta
          : await this.getRutaAccesos(destino, transporte);

        routeToDraw = new List(nodeList)
          .Join(
            new List<any>(this.animateMapService.nodos),
            (routeAcceso: any) => routeAcceso.nodo_ruta,
            node => node.nod_id,
            (routeAcceso, node) => {
              return { route: routeAcceso, node };
            }
          )
          .ToArray();

        await this.animateMapService.drawRoute(routeToDraw);
        // pin de servicios 
        // lastNode = routeToDraw[routeToDraw.length - 1].node;

        // pin =
        //   '<div class="talk-bubble tri-right round btm-left no-visible" id="acceso-' +
        //   lastNode.nod_id +
        //   '">';
        // pin +=
        //   '<img id="acceso-' +
        //   lastNode.nod_id +
        //   '" data-id="' +
        //   lastNode.nod_id +
        //   '" src="' + ultimoacceso.imagen_tipo_acceso + '"></div>';
        this.animateMapService.ListaInstrucciones.push({a: 'hasLlegado', b: 'assets/img/map-marker.png'});
        // await this.animateMapService.showPin(lastNode, pin, bounces);

        break;

      case 'estacionamiento':
        tipoDestino = 3;

        const rutaPIest = await this.getRutasEst(
          destino.punto_interes,
          transporte,
          undefined,
          tipoDestino
        );

        routeToDraw = new List(rutaPIest)
          .Join(
            new List<any>(this.animateMapService.nodos),
            (routePI: any) => routePI.nodo_ruta,
            node => node.nod_id,
            (routePI, node) => {
              return { route: routePI, node };
            }
          )
          .ToArray();

        await this.animateMapService.drawRoute(routeToDraw);
        lastNode = routeToDraw[routeToDraw.length - 1].node;

        // pin = '<div class="tooltip-pi acceso-pin no-visible" id="acceso-' + lastNode.nod_id + '">';
        // pin += '<img id="acceso-' + lastNode.nod_id + '" data-id="' + lastNode.nod_id + '" src="' + destino.logo + '"></div>';

        // await this.animateMapService.showPin(lastNode, pin, bounces);

        // Se muestra instrucción
        // $('.instrucions-ways .instrucciones p').hide('fast');
        // $('.instrucions-ways .instrucciones').append(
        //   $('<li>')
        //     .text('Ha llegado')
        //     .css('display', 'none')
        // );
        // $('.instrucions-ways .instrucciones li:last').velocity(
        //   'transition.slideLeftBigIn',
        //   { duration: 500 }
        // );
        this.animateMapService.ListaInstrucciones.push({a: 'hasLlegado', b: 'assets/img/map-marker.png'});
        // Se activa el botón para repetir ruta
        // $('.btn-repetir').show();

        break;
    }

    // Se desbloquean botones del mapa
    this.buttonDisable = false;
    $('.btn-tool').prop('disabled', false);

    // Se activa ruta
    // --- Registro global Analytics (homologado desde Antofagasta) ---
    try {
      const destinoNombre = destino && (destino.nombre || destino.descripcion || destino.punto_interes)
        ? String(destino.nombre || destino.descripcion || destino.punto_interes)
        : 'Destino';
      const tipo = mode || 'ruta';
      const env: any = environment;
      const origenTotem = env && env.totem ? String(env.totem) : 'Totem';
      this.analytics.sendRouteStart(origenTotem, tipo, destinoNombre);
      this.analytics.sendPageView(
        '/wayfinding/' + tipo,
        destinoNombre,
        {
          origin_totem: origenTotem,
          destination_name: destinoNombre,
          route_type: tipo,
          floor: destino.piso || destino.nivel || ''
        }
      );
    } catch (err) {
      console.warn('GA4 wayfinding error', err);
    }
    this.hasActiveRoute = this.animateMapService.propiedadesMapa.rutaActiva;
  }

  async getRutaAccesos(destino, transporte) {
    const rutasAccesos: any[] = await this.totemService
      .getRutasAccesos()
      .toPromise();
    console.log('rutas', rutasAccesos);
    const route = new List(rutasAccesos)
      .Where(item => item.totem_id === this.totem)
      .Where(item => item.id_acceso === destino)
      .SelectMany(item => new List(item.rutas))
      .Select((item: any) => item.local)
      .SelectMany(item => new List(item.transportes))
      .Select((item: any) => item.nodos)
      .FirstOrDefault(null);

    console.log('GetRutaAccesos', route);

    return route;
  }

  async getRutasPI(piid, transporte, destino, tipoDestino): Promise<any> {
    const rutasPI: any[] = await this.totemService.getRutaPi().toPromise();

    console.log('[ GetRutasPI ]', rutasPI);
    console.log('[ Destino ]', destino);
    console.log('[ PIID ]', piid);

    const route = new List(rutasPI)
      .Where(item => item.totem_id === this.totem)
      .Where(item => (destino ? item.nodo_destino === destino : true))
      .Where(item => (piid !== 0 ? item.id_punto_interes === piid : true))
      .Where(item => (tipoDestino ? item.tipo_destino === tipoDestino : true))
      .SelectMany(item => new List(item.rutas))
      .Select((item: any) => item.local)
      .SelectMany(item => new List(item.transportes))
      .OrderBy((item: any) => item.peso_ruta)
      .Where((item: any) => item.id_transporte === transporte)
      .Select((item: any) => item.nodos)
      .FirstOrDefault(null);

    return route;
  }
  async getRutasEst(piid, transporte, destino, tipoDestino): Promise<any> {
    const rutasPI: any[] = await this.totemService.getRutaPi().toPromise();

    console.log('[ GetRutasPI ]', rutasPI);
    console.log('[ Destino ]', destino);
    console.log('[ PIID ]', piid);
    const route = new List(rutasPI)
      .Where(item => item.totem_id === this.totem)
      .Where(item => (destino ? item.nodo_destino === destino : true))
      .Where(item => (piid !== 0 ? item.id_punto_interes === piid : true))
      .Where(item => (tipoDestino ? item.tipo_destino === tipoDestino : true))
      .SelectMany(item => new List(item.rutas))
      .Select((item: any) => item.local)
      .SelectMany(item => new List(item.transportes))
      .OrderBy((item: any) => item.peso_ruta)
      .Where((item: any) => item.id_transporte === transporte)
      .Select((item: any) => item.nodos)
      .FirstOrDefault(null);

    return route;
  }

  async getShortestRouteToAccess(accesos, transporte): Promise<any> {
    const rutaAccesos = await this.totemService.getRutasAccesos().toPromise();
    const route = new List<any>(rutaAccesos)
      .Where((item: any) => item.totem_id === this.totem)
      .Join(
        new List<any>(accesos),
        (routeAcc: any) => routeAcc.id_acceso,
        acc => acc.acc_id,
        (routeAcc, acc) => routeAcc
      )
      .SelectMany((item: any) => new List<any>(item.rutas))
      .Select((item: any) => item.local)
      .SelectMany((item: any) => new List<any>(item.transportes))
      .OrderBy((item: any) => item.peso_ruta)
      .Select((item: any) => item.nodos)
      .FirstOrDefault(null);

    return route;
  }

  calcSiglaPiso(piso: number) {
    return piso >= 0 ? `p${piso.toString()}` : `b${Math.abs(piso).toString()}`;
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }


  pisoActivo() {
    const piso = this.animateMapService.propiedadesMapa.pisoActivo.split('-')[0];
    return piso[1];
  }

  getInstrucciones() {
    return this.animateMapService.ListaInstrucciones;
  }

  getPuntoInteres() {
    return !this.puntoInteres ? '' : this.puntoInteres;
  }
  getServicioWayfinding() {
    return !this.tipoAcceso ? '' : this.tipoAcceso;
  }
  getButtonEnable() {
    return this.buttonDisable;
  }
}
